import request from '@/utils/request'

// 查询客户收货发票信息
export function findInvoiceInfo(params) {
  return request({
    url: `/invoice_infos`,
    method: 'get',
    params: params
  })
}

// 查询单个收货发票信息表单值
export function findInvoiceInfoForm(id) {
  return request({
    url: `customer/invoice_infos/${id}/form`,
    method: 'get'
  })
}

// 更新客户收货发票信息
export function updateInvoiceInfo(id, data) {
  return request({
    url: `customer/invoice_infos/${id}`,
    method: 'put',
    data
  })
}

// 创建收货发票信息
export function createInvoiceInfo(data) {
  return request({
    url: `customer/invoice_infos`,
    method: 'post',
    data
  })
}

// 设置默认收货发票信息
export function SetInvoiceInfoDefault(id) {
  return request({
    url: `customer/invoice_infos/${id}/default`,
    method: 'patch'
  })
}

// 删除收货发票信息
export function DeleteInvoiceInfo(id) {
  return request({
    url: `customer/invoice_infos/${id}`,
    method: 'delete'
  })
}
